import {
  AccountId,
  AccountKycAml,
  ApiResponse,
  PerformAccountKycAmlRequest,
  UpdateAccountKycAmlStatusRequest,
} from '@arrived/models';

import { api } from './api';
import { unwrapApiResponse } from './utils';

export const getAccountKycAml = async (accountId: AccountId) => {
  const response = await api.get<ApiResponse<AccountKycAml>>(`/accounts/${accountId}/kycaml`, {
    // TODO: Remove this pending BE response
    validateStatus: (status) => status === 422 || status < 300,
  });

  return unwrapApiResponse(response.data);
};

export interface PostAccountKycAmlRequest {
  accountId: AccountId;
  request: PerformAccountKycAmlRequest;
}

export const postAccountKycAml = async ({ accountId, request }: PostAccountKycAmlRequest) => {
  const response = await api.post<ApiResponse<AccountKycAml>>(`/accounts/${accountId}/kycaml`, request);

  return unwrapApiResponse(response.data);
};

export interface PutAccountKycAmlRequest {
  accountId: AccountId;
  request: UpdateAccountKycAmlStatusRequest;
}

export const putAccountKycAml = async ({ accountId, request }: PutAccountKycAmlRequest) => {
  const response = await api.put<ApiResponse<AccountKycAml>>(`/accounts/${accountId}/kycaml`, request);

  return unwrapApiResponse(response.data);
};
